export const reportingEndpoints = {
  createCustomReport: { method: 'post', path: '/my-reports' },
  listCustomReports: { method: 'get', path: '/my-reports' },
  getCustomReport: { method: 'get', path: '/my-reports/{id}' },
  updateCustomReport: { method: 'post', path: '/my-reports/{id}' },
  deleteCustomReport: { method: 'post', path: '/my-reports/{id}/delete' },
  listDataFields: { method: 'get', path: '/my-reports/data-fields' },
  generateCustomReport: { method: 'post', path: '/my-reports/{id}/generate' },
} as const
